import React from "react";
import { Delete } from "lucide-react";

/** Teclado numérico grande para cajas con pantalla táctil sin teclado físico.
 *  value es string: el componente sólo compone dígitos y delega el Enter. */
export const NumPad = ({ value, onChange, onEnter, testid = "numpad", enterLabel = "OK" }) => {
  const press = (k) => {
    const v = String(value ?? "");
    if (k === "del") return onChange(v.slice(0, -1));
    if (k === "clr") return onChange("");
    if (k === "00") return onChange(v + "00");
    return onChange(v + k);
  };
  const keys = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "00", "0", "del"];
  return (
    <div data-testid={testid} className="grid grid-cols-3 gap-2 select-none">
      {keys.map((k) => (
        <button
          key={k} type="button" data-testid={`${testid}-key-${k}`} onClick={() => press(k)}
          className={`h-14 rounded-xl border-2 text-2xl font-extrabold font-mono-num active:scale-95 transition-transform ${
            k === "del" ? "bg-rose-50 border-rose-200 text-rose-700" : "bg-white border-slate-200 text-slate-900 hover:border-sky-400"
          }`}
        >
          {k === "del" ? <Delete className="w-6 h-6 mx-auto" /> : k}
        </button>
      ))}
      <button type="button" data-testid={`${testid}-key-clr`} onClick={() => press("clr")}
              className="h-12 rounded-xl border-2 border-slate-200 bg-slate-50 font-bold text-slate-600">
        Borrar
      </button>
      <button type="button" data-testid={`${testid}-key-enter`} onClick={onEnter}
              className="h-12 col-span-2 rounded-xl bg-slate-900 text-white font-extrabold">
        {enterLabel}
      </button>
    </div>
  );
};

export default NumPad;
